import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import '@/pages/timeline/sections/timeline/timelineSections/certificate/style.css'
import { useSelector } from 'react-redux';
import { RootState } from '@/store/index';
import moment from 'moment';

export default function DeliveryConfirmed(props: any) {
    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);
    const { timeline } = useLocalTranslation();
    return (
        <div className='commonMainCon'>
            <p className='commonp1'>
                {timeline.certificateSection.deliveryConfirmed.p1}{' '}{moment(timelineDetails.certificateDeliveryConfirmedAt).format('DD MMM, YYYY')}
            </p>
        </div>
    );
};



